import { apiUrlPrefix } from '../../../config';

const extractNextChatMessages = async (chatId, communityId, index) => {
  try {
    if(communityId === undefined) {
      communityId = '';
    }
    const userId = localStorage.getItem('userId');
    const bearerToken = localStorage.getItem('accessToken');
    const response = await fetch(
      `${apiUrlPrefix}Discussion/getNext30Messages?discussionId=${chatId}&communityId=${communityId}&userId=${userId}&index=${index}`,
      {
        method: "GET",
        credentials: "include", // Include cookies in the request
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${bearerToken}` },
      }
    );

    if (response.ok) {
      const data = await response.json();
      // Return a resolved promise to signal completion
      return data;
    } else {
      console.error("Failed to fetch chat messages. Response:", response);
      return null; // Return null if failed
    }
  } catch (error) {
    console.error("Error fetching chat messages:", error);
    return null; // Return null on error
  }
};

export default extractNextChatMessages;
